var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.siteMenuFlyoutIsOpen
          ? _c(
              "div",
              {
                staticClass: "fixed inset-0 z-30",
                class: { "pt-smh": _vm.$root.siteMessageIsVisible },
              },
              [
                _c("div", { staticClass: "h-full bg-paint pt-shh" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "h-full flex flex-col overflow-y-scroll scrolling-touch",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "px-ogs-large flex-1 flex flex-col" },
                        [
                          _c("ul", { staticClass: "flex-1 py-6 space-y-6" }, [
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "text-lg focus:outline-none",
                                  attrs: { href: "/colours" },
                                },
                                [_vm._v("Colours")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "button",
                                {
                                  staticClass: "text-lg focus:outline-none",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openMenu(_vm.PAINTS_KEY)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  Shop Paints\n                "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "button",
                                {
                                  staticClass: "text-lg focus:outline-none",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openMenu(_vm.OILS_KEY)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  Shop Oils\n                "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "text-lg focus:outline-none",
                                  attrs: { href: "/contact" },
                                },
                                [_vm._v("Contact")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "button",
                                {
                                  staticClass: "text-lg focus:outline-none",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openMenu(_vm.ABOUT_KEY)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  Why Natural?\n                "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "text-lg focus:outline-none",
                                  attrs: { href: "/trade-paradise" },
                                },
                                [_vm._v("Trade")]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "space-x-6 flex justify-between pb-5",
                            },
                            [
                              _c("div", { staticClass: "space-x-6" }, [
                                _c(
                                  "a",
                                  { attrs: { href: "/shop/customer/login" } },
                                  [_vm._v("Login")]
                                ),
                                _vm._v(" "),
                                _c("a", { attrs: { href: "/gift-vouchers" } }, [
                                  _vm._v("Gift Vouchers"),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isOpenedMenu(_vm.PAINTS_KEY)
            ? _c("SiteMenuFlyoutMega", {
                attrs: {
                  heading: "Shop Paints",
                  "menu-data": _vm.paintsMenuData,
                },
                on: { close: _vm.closeMenu },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isOpenedMenu(_vm.OILS_KEY)
            ? _c("SiteMenuFlyoutMega", {
                attrs: { heading: "Shop Oils", "menu-data": _vm.oilsMenuData },
                on: { close: _vm.closeMenu },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isOpenedMenu(_vm.ABOUT_KEY)
            ? _c("SiteMenuFlyoutAbout", {
                attrs: { items: _vm.aboutMenuItems },
                on: { close: _vm.closeMenu },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }